export default {

  DRAWER_SET (state, payload) {
    state.drawer = payload
  },

  DRAWER_TOGGLE (state) {
    state.drawer = !state.drawer
  },

  NOTIFICATION (state, { type, text }) {
    state.notification.value = true
    if (type) state.notification.type = type
    if (text) state.notification.text = text
  },

  SET_SELECTED_GROUP (state, group) {
    // If no `group` argument is provided (or is null), reset to default
    state.selectedGroup = group || {
      id: null,
      description: 'New Group',
      visibility_type_id: 0,
      filers: []
    }
  }

}
